import client from "./client";

const questionBankApi = {
  // Get questions by chapter ID (correct endpoint)
  getQuestionsByChapter(chapterId, filters = {}) {
    return client
      .get(`/question-bank/chapter/${chapterId}`, { params: filters })
      .then((r) => r.data);
  },

  // Search questions across all chapters
  searchQuestions(params = {}) {
    return client
      .get("/question-bank/questions/search", { params })
      .then((r) => r.data);
  },

  // Create a new question (custom question)
  createQuestion(data) {
    return client.post("/question-bank/questions", data).then((r) => r.data);
  },

  // Update a question
  updateQuestion(id, data) {
    return client
      .patch(`/question-bank/questions/${id}`, data)
      .then((r) => r.data);
  },

  // Delete a question
  deleteQuestion(id) {
    return client
      .delete(`/question-bank/questions/${id}`)
      .then((r) => r.data);
  },

  // Get question by ID
  getQuestion(id) {
    return client
      .get(`/question-bank/questions/${id}`)
      .then((r) => r.data);
  },
};

export default questionBankApi;
